export const TURNSTILE_SITE_KEYS: { [tenant: string]: string } = {
	"": "0x4AAAAAAAD9O7_8_bHpv2iV",
	FX: "0x4AAAAAAAD9O7_8_bHpv2iV",
	RBW: "0x4AAAAAAAHN5nRrbO0p5g3l",
	GlobalCity: "0x4AAAAAAAI7nqJ8RANNIvDQ",
	Warface: ""
};
